module.exports = __webpack_public_path__ + "img/Stock_green_icon.8af3ab73.png";